<template>
    <div class="blog-posts">
        <Breadcrumb :breadcrumb="breadcrumb" class="mb-5"/>
        <b-container>
            <b-row class="intern">
                <b-col cols="12" lg="8" class="mb-4">
                    <b-row class="mb-5">
                        <b-col cols="12" lg="5">
                            <div class="aspect-ratio ratio-4-3">
                                <div class="aspect-content">
                                    <img class="object-fit-cover" v-lazy="imageUrl(post.image)" :alt="post.title">
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="7" class="post-data-start">
                            <div>
                                <div class="post-datetime">
                                    {{ $dayjs(post.datetime).format('LL') }}
                                </div>
                                <div class="post-title intern">
                                    {{ post.title }}
                                </div>
                            </div>
                            <div class="post-share">
                                <span>Compartilhe:</span>
                                <Share :title="post.title" :url="$route.fullPath"/>
                            </div>
                        </b-col>
                    </b-row>
                    <div class="post-text" v-html="post.text"></div>
                </b-col>
                <b-col cols="12" lg="4">
                    <BlogPostsProducts/>
                    <MoreBlogPosts :current_id="post.id"/>
                </b-col>
            </b-row>
        </b-container>
        <PreFooterInfo/>
    </div>
</template>

<script>
    import MoreBlogPosts from "~/components/MoreBlogPosts";
    import Share from "~/components/Share";
    import BlogPostsProducts from "~/components/BlogPostsProducts";
    import Breadcrumb from "~/components/Breadcrumb";
    import PreFooterInfo from "~/components/PreFooterInfo";
    import utils from '~/mixins/utils';

    export default {
        mixins: [utils],
        components: {
            MoreBlogPosts,
            BlogPostsProducts,
            Breadcrumb,
            Share,
            PreFooterInfo
        },
        head() {
            return {
                title: this.post.title,
                meta: [
                    {
                        hid: `twitter:card`,
                        name: 'twitter:card',
                        content: "summary_large_image"
                    },
                    {
                        hid: `og:title`,
                        property: 'og:title',
                        content: this.post.title
                    },
                    {
                        hid: `og:url`,
                        property: 'og:url',
                        content: `${this.$host}${this.$route.fullPath}`
                    },
                    {
                        hid: `og:image`,
                        property: 'og:image',
                        content: this.imageUrl(this.post.image)
                    },
                    {
                        hid: 'og:image:height',
                        property: 'og:image:height',
                        content: '315'
                    },
                    {
                        hid: 'og:image:width',
                        property: 'og:image:width',
                        content: '600'
                    }
                ]
            }
        },
        data: function () {
            return {
                post: {},
                imgNotLoad: 'data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjU3NXB4IiBoZWlnaHQ9IjM4NXB4IiB2aWV3Qm94PSIwIDAgNTc1IDM4NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiPgogIDxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI1NzUiIGhlaWdodD0iMzg1IiBmaWxsPSIjZjFmMWYxIiBzdHJva2Utd2lkdGg9IjAiICAvPgo8L3N2Zz4='
            }
        },
        computed: {
            id() {
                return this.$route.params.post.split('-').pop()
            },
            breadcrumb() {
                return [
                    {
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: 'Blog',
                        link: '/blog'
                    },
                    {
                        name: this.post.title,
                        link: null
                    }
                ]
            }
        },
        validate({params}) {
            if (!/^[a-zA-Z0-9_-]+$/.test(params.post)) {
                return false
            }
            return params.post.split("-").pop() > 0
        },
        async asyncData({params, res, $axios, req, app, error, redirect, route}) {
            try {
                const post = await $axios.$get(`api/v1/blogs/posts?blog_id=1&id=${params.post.split("-").pop()}`);
                if (route.path !== post.data.route) {
                    redirect(302, post.data.route);
                }
                return {
                    post: post.data,
                }
            } catch (e) {
                console.error(e)
                return error({statusCode: 404, message: e.message})
            }
        }
    }
</script>
